import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import PressSection from '../../Components/PressSection';
// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

// Blog images
import P_1 from '../../assets/images/Project1.webp';
import P_2 from '../../assets/images/Project2.webp';
import P_3 from '../../assets/images/Project3.webp';
import P_4 from '../../assets/images/Project4.webp';
import P_5 from '../../assets/images/Project5.webp';
import P_6 from '../../assets/images/Project6.webp';

export default function Press() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const presses = [
    {
      name: 'Press title here',
      writenBy: 'Author Name',
      image: P_1,
      link: '',
    },
    {
      name: 'Press title here',
      writenBy: 'Author Name',
      image: P_2,
      link: '',
    },
    {
      name: 'Press title here',
      writenBy: 'Author Name',
      image: P_3,
      link: '',
    },
    {
      name: 'Press title here',
      writenBy: 'Author Name',
      image: P_4,
      link: '',
    },
    {
      name: 'Press title here',
      writenBy: 'Author Name',
      image: P_5,
      link: '',
    },
    {
      name: 'Press title here',
      writenBy: 'Author Name',
      image: P_6,
      link: '',
    },
  ];

  return (
    <div className='press-page blogs-page'>
      <Helmet>
        <title>Starlife: Press</title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <PressSection presses={presses}/>
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
